var s = function (c) {
  return c.desc = "desc", c.asc = "asc", c;
}(s || {});

export { s as SortOrder };